import { Switch, SwitchTiny } from "@/components"

import type { FeatureFlagId } from "../types"

export interface FeatureFlagToggleProps {
  flagId: FeatureFlagId
  name: string
  description: string
  enabled: boolean
  onToggle: (flagId: FeatureFlagId) => void
}

export const FeatureFlagToggle: React.FC<FeatureFlagToggleProps> = ({
  flagId,
  name,
  description,
  enabled,
  onToggle,
}) => {
  return (
    <div className="flex items-start justify-between rounded-lg border border-p400-light bg-p300 p-4">
      <div className="flex-1">
        <h3 className="text-sm font-medium text-t100">{name}</h3>
        <p className="mt-1 text-sm text-t200">{description}</p>
      </div>
      <div className="ml-4">
        <Switch checked={enabled} onCheckedChange={() => onToggle(flagId)} />
      </div>
    </div>
  )
}
